import 'normalize.css';
import './index.scss';
import '@/initialize';

import ReactDOM        from 'react-dom/client';
import App             from '@/App';
import devToolbarStore from '@widesk-core/stores/devToolbarStore';
import * as Sentry     from '@sentry/react';
import authStore       from '@widesk-core/stores/authStore';
import cookie          from '@widesk-core/tools/cookie';
import getAuthCookiePrefix from '@/helpers/authCookiePrefix';

Sentry.init({
	enabled: process.env.NODE_ENV === 'production',
	dsn: 'https://fc327c0e162cdc1618487d6fddbca7c3@o240489.ingest.us.sentry.io/4510084762107904',
	integrations: [
		new Sentry.BrowserTracing({
			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
			tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
		}),
		new Sentry.Replay(),
	],
	// Performance Monitoring
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

if (__LOCAL__) {
	const _error = console.error;
	// Affichage d'un message pour chaque erreur dans la console
	console.error = function () {
		// eslint-disable-next-line prefer-rest-params
		const args = arguments;
		devToolbarStore.addConsoleError(Array.prototype.slice.apply(args).join(' '));
		return _error.apply(console, args as any);
	};
}

// Préfixe des cookies de token sur le staging (le préfixe de l'AuthStore widesk n'est pas modifiable après coup)
const authCookiePrefix = getAuthCookiePrefix();
authStore.setStorage(authCookiePrefix ? {
	getItem: (key: string) => cookie.getItem(`${authCookiePrefix}_${key}`),
	setItem: (key: string, value: string) => cookie.setItem(`${authCookiePrefix}_${key}`, value),
	removeItem: (key: string) => cookie.removeItem(`${authCookiePrefix}_${key}`),
} : cookie);

ReactDOM.createRoot(document.getElementById('root')!).render(
	// Désactivation de React.StrictMode car cela déclenche plusieurs fois les requêtes
	// ce qui entraine des dysfonctionnements avec les resolvable

	// <React.StrictMode>
	<App />,
	// </React.StrictMode>,
);
